import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/workspace/components/CTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FadeIn"] */ "/workspace/components/ui/motion.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/components/WhyUs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/WorkGrid.tsx");
